import React from 'react';
import { MarkerIcon } from '.';

export default () => (<MarkerIcon className='icon-map-pin' />);
